import { apiBase } from '@/config/runtime-config'

/**
 * Public certificate verification — no credential, deliberately.
 *
 * The people who most need to check a nomination certificate are the ones without an account
 * here: a returning officer, a journalist, a rival campaign. So this calls the open endpoint
 * with no Authorization header at all, and does not touch the admin client (which would
 * attach a staff token and make the request look like something it is not).
 */
export interface CertificateVerification {
  status: 'VALID' | 'REVOKED' | 'UNKNOWN'
  reference: string
  aspirantName: string | null
  partyName: string | null
  seatTypeCode: string | null
  unitName: string | null
  contestTitle: string | null
  issuedAt: string | null
  revokedAt: string | null
  revokeReason: string | null
}

export async function verifyCertificate(reference: string): Promise<CertificateVerification> {
  const response = await fetch(
    `${apiBase}/public/nomination-certificates/${encodeURIComponent(reference.trim())}`)
  if (response.status === 429) {
    throw new Error('Too many attempts. Please wait a moment and try again.')
  }
  if (!response.ok) {
    throw new Error('Could not check that reference. Please try again.')
  }
  return response.json() as Promise<CertificateVerification>
}
